<div class="layout-topbar">
  <div class="topbar-left">
    <a
      #menubutton
      tabindex="0"
      class="menu-button p-trigger"
      (click)="onMenuButtonClick()"
    >
      <i class="pi pi-chevron-left"></i>
    </a>
    <img
      class="horizontal-logo"
      [routerLink]="['/']"
      src="assets/layout/images/logos/app-logo.png"
      alt="diamond-layout"
    />
    <span class="topbar-separator"></span>
    <app-breadcrumb></app-breadcrumb>
    <img
      class="mobile-logo"
      src="assets/layout/images/logos/app-logo.png"
      alt="diamond-layout"
    />
  </div>

  <div class="layout-topbar-menu-section">
    <app-sidebar></app-sidebar>
  </div>
  <div class="layout-mask modal-in"></div>

  <div class="topbar-right">
    <ul class="topbar-menu">
     
     

      <li class="profile-item static sm:relative border-right-none">
        <a
          tabindex="0"
          pStyleClass="@next"
         
          enterActiveClass="scalein"
          leaveToClass="hidden"
          leaveActiveClass="fadeout"
          [hideOnOutsideClick]="true"
          (click)="onRightMenuClick()"
        >
        <!-- enterClass="hidden" -->
        <div class="w-2rem h-2rem text-base profile-picture bg-primary text-white border-round flex align-items-center justify-content-center"
            style="font-weight: bold;">
            <span>{{ profileInitial }}</span>
        </div>
          <!-- <img
            src="assets/demo/images/avatar/profile.jpg"
            alt="diamond-layout"
            class="profile-image"
          /> -->
          <div class="flex flex-column text-left p-0 line-height-2">
            <div class="ml-2">{{ fullName }}</div>
            <div class="ml-2 text-gray-600">{{ position }}</div>
          </div>
          <!-- <span class="profile-name ml-2">{{  }}</span> -->
        </a>
        <ul
          class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 right-0 z-5 top-auto"
        >
          <li>
            <a
              pRipple
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            >
              <i class="pi pi-user mr-3"></i>
              <span class="flex flex-column">
                <span class="font-semibold">Profile</span>
              </span>
            </a>
            <a
              pRipple
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            >
              <i class="pi pi-cog mr-3"></i>
              <span class="flex flex-column">
                <span class="font-semibold">Settings</span>
              </span>
            </a>
            <a
              pRipple
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            >
              <i class="pi pi-calendar mr-3"></i>
              <span class="flex flex-column">
                <span class="font-semibold">Calendar</span>
              </span>
            </a>
            <a
              pRipple
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            >
              <i class="pi pi-inbox mr-3"></i>
              <span class="flex flex-column">
                <span class="font-semibold">Inbox</span>
              </span>
            </a>
            <!-- ออกจากระบบ = ล้าง session ก่อนไปหน้า login (หน้า login ไม่ล้างให้แล้วถ้ายัง login อยู่) -->
            <a
              pRipple
              role="button"
              tabindex="0"
              class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
              (click)="logout()"
              (keydown.enter)="logout()"
            >
              <i class="pi pi-power-off mr-3"></i>
              <span class="flex flex-column">
                <span class="font-semibold">Logout</span>
              </span>
            </a>
          </li>
        </ul>
      </li>

      <!-- <li class="right-sidebar-item">
        <a tabindex="0" (click)="onRightMenuClick()">
          <i class="pi pi-align-right"></i>
        </a>
      </li> -->
    </ul>
  </div>
</div>
